<template>
  <div id="page">
    <div class="row topCardGrid" id="cards">
      <sp-card :valor="ativos.total_funcionarios" :sufix="$t('funcionalismo.perfil.cards.ativos-sufix')" classDesc="pull-right"
        :descricao="$t('funcionalismo.perfil.cards.media-etaria', {idade_media : ativos.media_idade || 0 })" :footerText="$t('funcionalismo.perfil.cards.ativos-rodape', {data_consulta: dataRef, valor: remuneracaoAtivos})">
      </sp-card>
      <sp-card :valor="inativos.total_funcionarios" :sufix="$t('funcionalismo.perfil.cards.inativos-sufix')" classDesc="pull-right"
        :descricao="$t('funcionalismo.perfil.cards.media-etaria', {idade_media : inativos.media_idade || 0 })" :footerText="$t('funcionalismo.perfil.cards.ativos-rodape', {data_consulta: dataRef, valor: remuneracaoInativos})">
      </sp-card>
      <sp-card :valor="abonoPermanencia.total_funcionarios" :sufix="$t('funcionalismo.perfil.cards.abonados-sufix')" classDesc="pull-right"
        :descricao="$t('funcionalismo.perfil.cards.media-etaria', {idade_media : abonoPermanencia.media_idade || 0 })" :footerText="$t('funcionalismo.perfil.cards.abonados-rodape', {data_consulta : dataPagina})"></sp-card>
    </div>
    <div class="row topCardGrid" id="cards">
      <sp-card :valor="ativos.total_funcionarios_efetivos" :sufix="$t('funcionalismo.perfil.cards.efetivos-sufix')" classDesc="pull-right"
        :descricao="$t('funcionalismo.perfil.cards.media-etaria', {idade_media : ativos.media_idade_efetivos || 0 })" :footerText="$t('funcionalismo.perfil.cards.efetivos-rodape', {data_consulta: dataRef, valor: remuneracaoEfetivos || 0})">
      </sp-card>
      <sp-card :valor="ativos.total_funcionarios_livre_provimento" :sufix="$t('funcionalismo.perfil.cards.livreProvimento-sufix')" classDesc="pull-right"
        :descricao="$t('funcionalismo.perfil.cards.media-etaria', {idade_media : ativos.media_idade_livre_provimento || 0 })" :footerText="$t('funcionalismo.perfil.cards.livreProvimento-rodape', {data_consulta: dataRef, valor: remuneracaoLivreProvimento || 0})">
      </sp-card>
      <sp-card :valor="ativos.total_funcionarios_comissionados" :sufix="$t('funcionalismo.perfil.cards.comissionados-sufix')" classDesc="pull-right"
        :descricao="$t('funcionalismo.perfil.cards.media-etaria', {idade_media : ativos.media_idade_comissionados || 0 })" :footerText="$t('funcionalismo.perfil.cards.comissionados-rodape', {data_consulta: dataRef, valor: remuneracaoComissionados || 0})"></sp-card>
    </div>

    <div class="row">
      <div class=" flex col md6 sm12">
        <sp-360-panel :title="$t('funcionalismo.perfil.painel.escolaridade.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" class="content">
          <div class="row t12">
            <multiselect v-model="valueEscol"
              :options="listaOrgaos"
              :custom-label="nameWithLang"
              :placeholder="$t('funcionalismoAtivosInativos.multiselectOrgao')"
              @input="multiselectEscolaridade" 
              class="lg6 md6 sm6"/>
            <va-button-toggle
              id="toggle-button"
              outline small
              v-model="coagulado"
              :options="toggleButtonOptionsCasos"
              color="info"
              @input="onToggleChangeCasos"

            />
            <va-button-toggle
              id="toggle-button"
              outline small
              v-model="seletorEscolaridade"
              :options="toggleButtonOptionsSeletor"
              color="info"
              @input="onToggleChangeEscolaridade"
            />

          </div>
          <sp360-chart ref="chartEscolaridade" id="chartEscolaridade" type="donut" :data="dataEscolaridade" class="toprow" :options="optionsEscolaridade" />
        </sp-360-panel>
      </div>

      <div class="flex col md6 sm12">
        <sp-360-panel  :title="$t('funcionalismo.perfil.painel.contratacao.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" class="content">
            <div class="row">
              <multiselect v-model="valueCont"
              :options="listaOrgaos"
              :custom-label="nameWithLang"
              :placeholder="$t('funcionalismoAtivosInativos.multiselectOrgao')"
              @input="multiselectContrato" class="lg6 md6 sm6"/>
            </div>
            <sp360-chart id="chartLivreprovimento" type="donut" :data="dataContrato" class="toprow" :options="optionsContratacao" />
        </sp-360-panel> 
      </div>

      <div class="content flex col md12 sm12">
        <sp-360-panel :title="$t('funcionalismo.perfil.painel.racaSexo.titulo')" class="flex content" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <div class="row">
          <multiselect v-model="valueRacaSexo"
            :options="listaOrgaos"
            :custom-label="nameWithLang"
            :placeholder="$t('funcionalismoAtivosInativos.multiselectOrgao')"
            @input="multiselectRacaSexo"/>
          <va-button-toggle
              id="toggle-button"
              outline small
              v-model="seletorRaceSexo"
              :options="toggleButtonOptionsSeletor"
              color="info"
              @input="onToggleChangeRacaSexo"
            />
          </div>
          <sp360-chart id="chartRacaSexo" type="vertical-bar" :data="dataRacaSexo" :options="optionsRacaSexo" class="toprow"/>
        </sp-360-panel>
      </div>
    </div>

    <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('funcionalismo.perfil.painel.folhaPorOrgao.titulo')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <va-tabs class="tabPadding" v-model="showTableOrgao">
            <va-tab v-for="option in showTableOrgaoOptions" :key="option.atributo">
              {{ option.label }}
            </va-tab>
          </va-tabs>
          <div v-show="!showTableOrgao">
            <va-button-toggle
              id="toggle-button"
              outline small
              v-model="seletorFolha"
              :options="toggleButtonOptionsSeletor"
              color="info"
              @input="onToggleChangeFolha"
            />
            <sp360-chart id="folhaBar" type="vertical-bar" :data="dataOrgao" :options="optionsOrgao"
              v-show="toggle==='bar'" />
          </div>
          <div v-show="showTableOrgao">
            <sp360-data-table v-show="showTableOrgao" id="tabelaFolhaPorOrgao" ref="tabelaFolhaPorOrgao"
              :apiMode="false" :data="tabelaFolhaPorOrgao.data" :fields="tabelaFolhaPorOrgao.fields"
              :perPage="itemsPerPage" :onEachSide="1" :sortFunctions="tabelaFolhaPorOrgao.sortFunctions" />
          </div>
          <div v-show="toggle==='bolha'">
            <div id="chartdiv" class="bubble" />
            <div id="legenddiv" />
          </div>
        </sp-360-panel>
      </div>
    </div>
   <!-- <div v-show="!showTablePerCapita">
       <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel title="Folha de pagamento por orgão per capita">
          <va-tabs class="tabPadding" v-model="showTablePerCapita">
            <va-tab v-for="option in showTableOrgaoOptions" :key="option.atributo">
              {{ option.label }}
            </va-tab>
          </va-tabs>

          <div v-show="!showTablePerCapita">
            <sp360-chart id="folhaBar" type="vertical-bar" :data="dataOrgaoPerCapita"
              :options="optionsOrgaoPerCapita" />
          </div>

          <div v-show="showTablePerCapita">
            <sp360-data-table v-show="showTablePerCapita" id="tabelaFolhaPerCapita" ref="tabelaFolhaPerCapita"
              :apiMode="false" :data="tabelaFolhaPerCapita.data" :fields="tabelaFolhaPerCapita.fields"
              :perPage="itemsPerPage" :onEachSide="1" :sortFunctions="tabelaFolhaPerCapita.sortFunctions" />
          </div>
        </sp-360-panel>
      </div>
    </div> -->
    <sp-360-panel :title="$t('funcionalismo.perfil.painel.etariedadePorOrgao.titulo') + '- ' + orgaoSelecionado" class="flex" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
      <div class="row">
        <div class="flex sm6" >
          <va-button-toggle
              id="toggle-button"
              outline small
              v-model="seletorEtariedade"
              :options="toggleButtonOptionsSeletor"
              color="info"
              @input="onToggleChangeEtariedade"
            />
          <va-input class="filter-input"
            v-model="termo"
            placeholder="Pesquisar"
            removable
            @input="pesquisa"
          />

          <sp360-data-table class="flex " v-show="true" id="tabelaOrgao" ref="tabelaOrgao"
            :apiMode="false"
            :data="tabelaOrgaos.dadosFiltrados"
            :fields="tabelaOrgaos.fields"
            :perPage="tabelaOrgaos.itemsPerPage"
            :onEachSide="1"
            :sortFunctions="tabelaFolhaPorOrgao.sortFunctions"
            :striped="true"
            :clickable="true"
            @row-clicked="clickedOrgao"
            :row-class="rowClass"
          />
        </div>

        <div class="flex md6">
          <sp360-chart  class="toprow" id="chartFaixaEtaria" type="vertical-bar" :data="chartFaixaEtaria.data" :options="chartFaixaEtaria.options" />
        </div>
      </div>
    </sp-360-panel>
  </div>
</template>

<script>
import CorUtils from '@/utils/CorUtils'
import MethGlob from '@/utils/MetodosGlobais'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import Overlay from '@/assets/geojson/spoverlay'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360List from '@/components/ui/list/VaList'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Legenda from '@/components/maps/360-maps/Legenda'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import * as am4plugins_forceDirected from '@amcharts/amcharts4/plugins/forceDirected'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

export default {
  name: 'ativosInativos',
  mixins: [Overlay, Legenda],
  components: {
    SpCard,
    Multiselect,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
  },

  data () {
    return {
      dataRef: new Date(),
      fonte: '',
      coagulado: 0,
      toggleButtonOptionsCasos: [
        { label: 'Agrupado', value: 0 },
        { label: 'Desagrupado', value: 1 },
      ],
      seletor: 0,
      seletorEscolaridade: 0,
      seletorFolha: 0,
      seletorEtariedade: 0,
      seletorRaceSexo: 0,
      toggleButtonOptionsSeletor: [
        { label: 'Todos', value: 0 },
        { label: 'Efetivos', value: 1 },
        { label: 'Livre Provimento', value: 2 },
        { label: 'Em Comissão', value: 3 },
      ],

      orgaoSelecionado: 'São Paulo',
      dataConsulta: null,
      ativos: 0,
      inativos: 0,
      abonoPermanencia: 0,
      comissionados: 0,
      dataRacaSexo: {},
      optionsRacaSexo: {},
      dataEscolaridade: {},
      dataContrato: {},
      optionsEscolaridade: {},
      optionsContratacao: {},
      dataOrgao: {},
      optionsOrgao: {},
      dataOrgaoPerCapita: {},
      optionsOrgaoPerCapita: {},
      toggle: 'bar',
      toggleOptions: [{ label: 'Barras', value: 'bar' }, { label: 'Bolhas', value: 'bolha' }],

      showTableOrgaoOptions: [
        {
          atributo: 0,
          label: 'Gráfico',
        },
        {
          atributo: 1,
          label: 'Tabela',
        },
      ],
      showTableOrgao: 0,
      showTablePerCapita: 0,
      itemsPerPage: 12,

      tabelaFolhaPorOrgao: {
        data: [],
        sortFunctions: {
          'nome_secretaria': MethGlob.ordenaTabela,
          'folha_pagamento_bruta': MethGlob.ordenaTabelaParseFloat,
          'folha_pagamento_bruta_comissionados': MethGlob.ordenaTabelaParseFloat,
          'folha_pagamento_bruta_efetivos': MethGlob.ordenaTabelaParseFloat,
          'folha_pagamento_bruta_livre_provimento': MethGlob.ordenaTabelaParseFloat,
        },
        fields: [
          {
            name: 'nome_secretaria',
            sortField: 'nome',
            title: 'Órgão',
          },
          {
            name: 'folha_pagamento_bruta_efetivos',
            sortField: 'folha_pagamento_bruta_efetivos',
            title: 'Folha de Pagamento Bruto Concursados',
            callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
            width: '12%',
          },
          {
            name: 'folha_pagamento_bruta_livre_provimento',
            sortField: 'folha_pagamento_bruta_livre_provimento',
            title: 'Folha de Pagamento Bruto Livre Provimento',
            callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
            width: '12%',
          },
          {
            name: 'folha_pagamento_bruta_comissionados',
            sortField: 'folha_pagamento_bruta_comissionados',
            title: 'Folha de Pagamento Bruto em Comissão',
            callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
            width: '12%',
          },
          {
            name: 'folha_pagamento_bruta',
            sortField: 'folha_pagamento_bruta',
            title: 'Folha de Pagamento Bruta Total',
            callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
            width: '12%',
          },
        ],
      },

      tabelaFolhaPerCapita: {
        data: [],
        sortFunctions: {
          'nome_secretaria': MethGlob.ordenaTabela,
          'per_capita': MethGlob.ordenaTabelaParseInt,
          'total_pessoas': MethGlob.ordenaTabelaParseInt,
        },
        fields: [
          {
            name: 'nome_secretaria',
            sortField: 'nome',
            title: 'Orgão',
          },
          {
            name: 'per_capita',
            sortField: 'per_capita',
            title: 'Folha de Pagamento Per Capita',
            callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
            width: '12%',
          },
          {
            name: 'total_pessoas',
            sortField: 'total_pessoas',
            title: 'Total de Pessoas',
            callback: function (value) { return value.toLocaleString('pt-BR') },
            width: '12%',
          },
        ],
      },

      tabelaOrgaos: {
        data: [],
        dadosFiltrados: [],
        itemsPerPage: 9,
        fields: [
          {
            name: 'nome',
            sortField: 'nome',
            title: 'Orgão',
          },

          {
            name: 'total',
            sortField: 'total',
            title: 'Total',
            callback: function (value) { return MethGlob.formatarGrandesNumeros(value) },
          },
        ],
        sortFunctions: {
          'nome': MethGlob.ordenaTabela,
          'total': MethGlob.ordenaTabelaParseInt,
        },
      },

      dadosFaixaEtaria: {
        'porOrgao': {},
        'municipio': {},
      },

      chartFaixaEtaria: {
        data: {},
        options: {},
      },

      valueEscol: { nome: 'São Paulo' },
      valueCont: { nome: 'São Paulo' },
      valueRacaSexo: { nome: 'São Paulo' },
      listaOrgaos: [],
      escolaridadePorOrgao: [],
      contratacaoPorOrgao: [],
      racaSexoPorOrgao: [],
      cores: [],
      termo: null,
      dadosFaixaEtariaSelecionados: null,
      etariedadeProp: null,
      propOrgao: null,
      propOrgaoPerCapta: null,
      propEscolaridade: 'total',
      propRacaSexo: 'total',
      
    }
  },

  computed: {
    remuneracaoAtivos () { return this.ativos ? this.ativos.remuneracao_bruta.toLocaleString('pt-BR') : 0 },
    remuneracaoInativos () { return this.inativos ? this.inativos.remuneracao_bruta.toLocaleString('pt-BR') : 0 },
    dataPagina () { return this.dataConsulta ? this.dataConsulta.toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR') },
    tabSelector () { return this.showTableOrgao },
    remuneracaoEfetivos () { return this.ativos ? this.ativos.remuneracao_bruta_efetivos.toLocaleString('pt-BR') : 0 },
    remuneracaoLivreProvimento () { return this.ativos ? this.ativos.remuneracao_bruta_livre_provimento.toLocaleString('pt-BR') : 0 },
    remuneracaoComissionados () { return this.ativos ? this.ativos.remuneracao_bruta_comissionados.toLocaleString('pt-BR') : 0 },
  },

  created () {

    Promise.all([
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorTipoRegime', {}),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorEscolaridade', {}),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorOrgao', {}),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorCargo', {}),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorTipoRacaSexo', {}),
      this.$store.dispatch('funcionalismo/buscarServidoresPorFaixaEtaria', { agrupamento: 'secretaria', inicio: '' }),
      this.$store.dispatch('funcionalismo/buscarServidoresPorFaixaEtaria', { inicio: '' }),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorEscolaridade', { agrupamento: 'orgao' }),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorTipoRacaSexo', { agrupamento: 'orgao' }),
      this.$store.dispatch('funcionalismo/distribuicaoPorRegimeContratacao', {}),
      this.$store.dispatch('funcionalismo/distribuicaoPorRegimeContratacao', { agrupamento: 'orgao' }),

    ]).then(respostas => {
      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
      this.cores = _.shuffle(CorUtils.getVetorCoresPorTom('medio'))
      this.calcularCards(respostas[0].data.data)

      this.optionsEscolaridade = {
        responsive: true,
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 40,
            bottom: 40,
          },
          margin: 100,
        },
        plugins: { 
          datalabels: {
            formatter: (value, ctx) => {
                let sum = 0
                let dataArr = ctx.chart.data.datasets[0].data
                dataArr.map(data => {
                  sum += data
                })
                let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
                return percentage
              },
            color: '#000',
            display: 'auto',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        legend: {
          position: 'left',
          labels: {
            usePointStyle: 'true',
          },
        },
      } 

      this.optionsContratacao = {
        responsive: true,
        tooltips: {
          callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 40,
            bottom: 40,
          },
          margin: 100,
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
              return percentage
            },
            color: '#000',
            display: 'auto',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        },
        legend: {
          position: 'left',
          labels: {
            usePointStyle: 'true',
          },
        },
      }

      this.dadosEscolaridade = respostas[1].data.data
      this.dadosOrgaoPerCapita = respostas[2].data.data
      this.dadosRacaSexo = respostas[4].data.data
      
      this.dataEscolaridade = this.montarGraficoEscolaridade(respostas[1].data.data)
      this.dataContrato = this.montarGraficoContratacao(respostas[9].data.data)

      this.optionsOrgao = this.getchartOptions('Orgão', 'Folha de Pagamento (R$)')
      this.dataOrgao = this.montarGraficoPorOrgao(this.dadosOrgaoPerCapita, this.optionsOrgao)

      this.optionsOrgaoPerCapita = this.getchartOptions('Orgão', 'Folha de Pagamento Per Capita (R$)')
      this.dataOrgaoPerCapita = this.montarGraficoPerCapita(this.dadosOrgaoPerCapita, this.optionsOrgaoPerCapita, 'per_capita')

      this.optionsRacaSexo = this.getchartOptions('Raça', 'Numero de servidores')
      this.dataRacaSexo = this.montarGraficoPorRacaCor(respostas[4].data.data, this.optionsRacaSexo)

      this.populateTabelasFolhaPorOrgao(respostas[2].data.data)

      this.dadosFaixaEtaria.municipio = respostas[6].data.data
      this.dadosFaixaEtaria.porOrgao = _.groupBy(respostas[5].data.data, 'nome')

      _.remove(respostas[5].data.data, (x) => { return x.nome === 'PREFEITURA DO MUNICIPIO DE SAO PAULO' })
      this.tabelaOrgaos.dadosFiltrados = _.orderBy(respostas[5].data.data, 'nome')
      this.tabelaOrgaos.data = _.orderBy(respostas[5].data.data, 'nome')

      this.dadosEtariedade = this.dadosFaixaEtaria.municipio[0]
      this.dadosFaixaEtariaSelecionados = this.dadosEtariedade

      this.populatePieChartFaixaEtaria()

      this.carregarListaOrgaos(_.orderBy(respostas[5].data.data, 'nome'))

      this.escolaridadePorOrgao = _.groupBy(respostas[7].data.data, 'orgao')
      this.racaSexoPorOrgao = _.groupBy(respostas[8].data.data, 'orgao')
      this.contratacaoPorOrgao = _.groupBy(respostas[10].data.data, 'orgao')

      Object.assign(this.escolaridadePorOrgao, { 'São Paulo': respostas[1].data.data })
      Object.assign(this.racaSexoPorOrgao, { 'São Paulo': respostas[4].data.data })
      Object.assign(this.contratacaoPorOrgao, { 'São Paulo': respostas[9].data.data })

      this.multiselectEscolaridade()
      this.multiselectContrato()

    })

    
  },

  methods: {
    onToggleChangeCasos (event) {
      this.multiselectEscolaridade(this.valueEscol)
    },

    onToggleChangeEscolaridade (event) {
      this.propEscolaridade = 'total'
      if (this.seletorEscolaridade === 1) {
        this.propEscolaridade = 'total_efetivos'
      } else if (this.seletorEscolaridade === 2) {
        this.propEscolaridade = 'total_livre_provimento'
      } else if (this.seletorEscolaridade === 3) {
        this.propEscolaridade = 'total_comissionados'
      }
      this.multiselectEscolaridade(this.valueEscol)
    },
    onToggleChangeFolha (event) {
      this.propOrgao = 'folha_pagamento_bruta'
      this.propOrgaoPerCapta = 'per_capita'
      if (this.seletorFolha === 1) {
        this.propOrgao = 'folha_pagamento_bruta_efetivos'
        this.propOrgaoPerCapta = 'per_capita_efetivos'
      } else if (this.seletorFolha === 2) {
        this.propOrgao = 'folha_pagamento_bruta_livre_provimento'
        this.propOrgaoPerCapta = 'per_capita_livre_provimento'
      } else if (this.seletorFolha === 3) {
        this.propOrgao = 'folha_pagamento_bruta_comissionados'
        this.propOrgaoPerCapta = 'per_capita_comissionados'
      }
      this.dataOrgao = this.montarGraficoPorOrgao(this.dadosOrgaoPerCapita, this.optionsOrgao, this.propOrgao)
      this.dataOrgaoPerCapita = this.montarGraficoPerCapita(this.dadosOrgaoPerCapita, this.optionsOrgaoPerCapita, this.propOrgaoPerCapta)
    },
    onToggleChangeEtariedade (event) {
      this.etariedadeProp = null
      if (this.seletorEtariedade === 1) {
        this.etariedadeProp = '_efetivo'
      } else if (this.seletorEtariedade === 2) {
        this.etariedadeProp = '_livre_provimento'
      } else if (this.seletorEtariedade === 3) {
        this.etariedadeProp = '_comissionado'
      } 
      this.populatePieChartFaixaEtaria()
    },
    onToggleChangeRacaSexo (event) {
      this.propRacaSexo = 'total'
      if (this.seletorRaceSexo === 1) {
        this.propRacaSexo = 'total_efetivos'
      } else if (this.seletorRaceSexo === 2) {
        this.propRacaSexo = 'total_livre_provimento'
      } else if (this.seletorRaceSexo === 3) {
        this.propRacaSexo = 'total_comissionados'
      }
      this.multiselectRacaSexo(this.valueRacaSexo)
    },

    onToggleChangeSeletor (event) {
      this.seletorEscolaridade = this.seletor
      this.seletorFolha = this.seletor
      this.seletorEtariedade = this.seletor
      this.seletorRaceSexo = this.seletor

      this.onToggleChangeEscolaridade()
      this.onToggleChangeFolha()
      this.onToggleChangeEtariedade()
      this.onToggleChangeRacaSexo()
    },

    multiselectEscolaridade (value) {
      this.valueEscol = value || { nome: 'São Paulo' }
      this.dataEscolaridade = this.montarGraficoEscolaridade(this.escolaridadePorOrgao[this.valueEscol.nome])
    },

    multiselectContrato (value) {
      this.valueCont = value || { nome: 'São Paulo' }
      this.dataContrato = this.montarGraficoContratacao(this.contratacaoPorOrgao[this.valueCont.nome])
    },

    multiselectRacaSexo (value) {
      this.valueRacaSexo = value || { nome: 'São Paulo' }
      this.optionsRacaSexo = this.getchartOptions('Raça', 'Numero de servidores')
      this.dataRacaSexo = this.montarGraficoPorRacaCor(this.racaSexoPorOrgao[this.valueRacaSexo.nome], this.optionsRacaSexo, this.propRacaSexo)
    },

    pesquisa: _.debounce(function (term) {
      this.termo = term
      let a = []

      if ((!Number.isNaN(parseInt(term))) && term != '') {
        a = this.$refs.tabelaOrgao.filterByNumber(this.dados.data, this.termo)
      } else {
        a = this.$refs.tabelaOrgao.filterByString(this.tabelaOrgaos.data, this.termo)
      }

      this.tabelaOrgaos.dadosFiltrados = _.orderBy(a, 'folha_pagamento_bruta')
    }, 400),

    calcularCards (dados) {
      if (dados) {
        this.dataConsulta = new Date(dados[0].data_folha_pagamento)
        this.comissionados = dados[0]
        this.inativos = dados[1]
        this.ativos = dados[2]
        this.abonoPermanencia = dados[0]
        let folha = 0
        dados.forEach(e => {
          folha += Number.parseFloat(e.remuneracao_bruta)
        })
        this.totalFolha = MethGlob.formatarGrandesNumeros(folha)
        this.mediaIdade = this.ativos.media_idade
      }
    },

    montarGraficoEscolaridade (dados) {
      let prop = this.propEscolaridade
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        backgroundColor: _.shuffle(CorUtils.getVetorCoresPorTom('medio')),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        label: 'Servidores por grau de escolaridade',
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value, ctx) => {
            let sum = 0
            let dataArr = ctx.chart.data.datasets[0].data
            dataArr.map(data => {
              sum += data
            })
            let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
            return percentage
          },
          anchor: 'end',
          align: 'end',
          display: 'auto',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }
      let superior = 0
      let tecnico = 0
      let medio = 0
      let fundamental = 0
      let fundamentaIncompleto = 0
      let nao_informado = 0

      if (this.coagulado) {
        dados.forEach(e => {
          if (e[prop] > 0) {
            chartData.labels.push(e.escolaridade)
            dataset.data.push(e[prop])
            dataset.label = 'Servidores'
          }
        })
      } else {
        dados.forEach(e => {
          switch (e.escolaridade.toLowerCase()) {
            case ('superior completo' || 'licenciatura plena completa ' || 'licenciatua curta completa') :
              superior += e[prop]
              break
            case ('licenciatura plena completa') :
              superior += e[prop]
              break
            case ('licenciatua curta completa') :
              superior += e[prop]
              break
            case 'ensino medio - completo':
              medio += e[prop]
              break
            case 'ensino medio - tecnico - completo':
              tecnico += e[prop]
              break
            case 'fund i - completo':
              fundamentaIncompleto += e[prop]
              break
            case 'fund i - incompleto':

              fundamentaIncompleto += e[prop]
              break
            case 'fund ii - completo':
              fundamental += e[prop]
              break
            case 'nao informado':
              nao_informado += e[prop]
              break
          }
        })
        let x = [{ v: superior, s: 'Superior Completo' }, { v: tecnico, s: 'Ensino Medio Tecnico Completo' }, { v: medio, s: 'Ensino Medio Completo' }, { v: fundamental, s: 'Ensino Fundamental Completo' }, { v: fundamentaIncompleto, s: 'Ensino Fundamental Incompleto' }, {v: nao_informado, s: 'Não Informado'}]
        x.forEach(e => {
          if (e.v > 0) {
            chartData.labels.push(e.s)
            dataset.data.push(e.v)
            dataset.label = 'Servidores'
          }
        })
      }
      chartData.datasets.push(dataset)
      return chartData
    },

    montarGraficoContratacao(dados) {
      let prop = 'total'
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        backgroundColor: _.shuffle(CorUtils.getVetorCoresPorTom('medio')),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        label: 'Servidores por tipo de Contratacao',
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value, ctx) => {
            let sum = 0
            let dataArr = ctx.chart.data.datasets[0].data
            dataArr.map(data => {
            sum += data
            })
            let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
            return percentage
          },
          anchor: 'end',
          align: 'end',
          display: 'auto',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }
      let admitido = 0
      let cargEletivo = 0
      let contrTeDeterm = 0
      let efetiv = 0
      let comissao = 0
      let requisita = 0
      let somatorio =0

      if (this.coagulado) {
        dados.forEach(e => {
          chartData.labels.push(e.regime_contratacao)
          dataset.data.push(e[prop])
          dataset.label = 'Servidores'
        })
      } else {
        dados.forEach(e => {
          switch (e.regime_contratacao) {
          case ('ADMITIDO') :
            admitido += e[prop]
            somatorio += e[prop]
            break
          case ('CARGO ELETIVO') :
            cargEletivo += e[prop]
            somatorio += e[prop]
            break
          case ('CONTR TEMPO DETERM') :
            contrTeDeterm += e[prop]
            somatorio += e[prop]
            break
          case ('EFETIVO'):
            efetiv += e[prop]
            //somatorio += e[prop]
            break
          case ('EM COMISSAO'):
            comissao += e[prop]
            somatorio += e[prop]
            break
          case ('REQUISITADO'):
            requisita += e[prop]
            somatorio += e[prop]
            break
          }
        })
        let x = [{ v: admitido, s: 'Admitido' }, 
                { v: cargEletivo, s: 'Cargo Eletivo' }, 
                { v: contrTeDeterm, s: 'Contrato com tempo determinado' }, 
                { v: comissao, s: 'Em Comissão' }, 
                {v: requisita, s: 'Requisitado'}]
        x.forEach(e => {
          if (e.v > 0) {
            chartData.labels.push(e.s)
            dataset.data.push(e.v)
            dataset.label = 'Servidores'
          }
        })
      }
      chartData.datasets.push(dataset)
      return chartData
    },

    montarGraficoPorCargo (dados) {
      let chartData = { datasets: [], labels: [] }

      let dataset = {
        backgroundColor: '#fc0303',
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => value.toLocaleString('pt-BR'),
          anchor: 'end',
          // rotation: 0,
          align: 'end',
          display: 'true',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }

      dados.forEach(element => {
        if (element) {
          chartData.labels.push(element.cargo)
          dataset.data.push(element.total_pessoas)
          dataset.label = 'Servidores Por Cargo'
        }
      })

      chartData.datasets.push(dataset)

      return chartData
    },

    montarGraficoPorOrgao (dados, options, campo) {
      let chartData = { datasets: [], labels: [] }
	    let dataset = []
      dataset[0] = {
        order: 2,
        backgroundColor: campo ? CorUtils.getCorPorNomeSp360('amarelo-claro') : CorUtils.getCorPorNomeSp360('verde-limao-medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],

        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => 'R$' + MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: -90,
          align: 'end',
          display: 'true',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }
      let cor = CorUtils.getCorPorNomeSp360('azul-claro')
      dataset[1] = {
        order: 1,
        backgroundColor: cor,
        borderColor: cor,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: 0,
          align: 'end',
          display: false,
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
        type: 'line',
        yAxisID: 'LineAxis',
        fill: false,
      }

      if (!campo) campo = 'folha_pagamento_bruta'
      dados = _.orderBy(dados, campo, 'desc')
      dados = dados.slice(0, 20)
      let total = 0
      dados.forEach(element => {
        if (element) {
          let nome = MethGlob.abreviarOrgaos(element.nome_secretaria)
          chartData.labels.push(nome)
          dataset[0].data.push(element[campo])
          dataset[0].label = 'Folha por Orgão'
          total += element[campo] || 0
        }
      })

      let aux = 0
      dados.forEach(element => {
        aux += ((element[campo] / total) * 100)
        dataset[1].data.push(aux)
        dataset[1].label = 'Acumulado'
      })

      chartData.datasets.push(dataset[0])
      chartData.datasets.push(dataset[1])

      options.layout.padding.top = 30
      options.scales.yAxes[0].type = 'logarithmic'
      options.scales.yAxes[0].ticks.maxTicksLimit = 10

      options.scales.yAxes.push({
        id: 'LineAxis',
        position: 'right',
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'Percentual de cada orgão em relação ao total (%)',
        },
        ticks: {
          max: 100,
          callback: function (value, index, values) {
            return value + '%'
          },
        },
      })

      options.scales.yAxes[0].ticks.callback = function (value, index, values) { return 'R$' + MethGlob.formatarGrandesNumeros(value) }

      return chartData
    },

    montarGraficoPerCapita (dados, options, campo) {
      let chartData = { datasets: [], labels: [] }
      let dataset = []
      dataset[0] = {
        order: 2,
        backgroundColor: campo ? CorUtils.getCorPorNomeSp360('amarelo-claro') : CorUtils.getCorPorNomeSp360('verde-limao-medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => 'R$' + MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: -90,
          align: 'end',
          display: 'true',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }

      let cor = CorUtils.getCorPorNomeSp360('azul-claro')

      dataset[1] = {
        order: 3,
        backgroundColor: cor,
        borderColor: cor,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'middle',
          rotation: -90,
          align: 'end',
          display: true,
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
        type: 'bar',
        yAxisID: 'LineAxis',
        fill: false,
      }

      if (!campo) campo = 'folha_pagamento_bruta'
      dados = _.orderBy(dados, campo, 'desc')

      let total = 0

      dados.forEach(element => {
        if (element) {
          let nome = MethGlob.abreviarOrgaos(element.nome_secretaria)
          chartData.labels.push(nome)
          dataset[0].data.push(element[campo])
          dataset[0].label = 'Folha por Orgão'
          total += element[campo] || 0
        }
      })

      dados.forEach(element => {
        dataset[1].data.push(element.total_pessoas)
        dataset[1].label = 'Servidores'
      })

      chartData.datasets.push(dataset[0])
      chartData.datasets.push(dataset[1])

      options.layout.padding.top = 30
      options.scales.yAxes[0].type = 'linear'

      options.scales.yAxes.push({
        id: 'LineAxis',
        position: 'right',
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'Servidores Ativos no Orgão',
        },
        ticks: {
          callback: function (value, index, values) {
            return MethGlob.formatarGrandesNumeros(value)
          },
        },
      })

      options.scales.yAxes[0].ticks.callback = function (value, index, values) { return 'R$' + MethGlob.formatarGrandesNumeros(value) }
      options.scales.yAxes[0].ticks.autoSkip = false

      return chartData
    },

    montarGraficoPorRacaCor (dados, options, prop = 'total') {
      let chartData = { datasets: [], labels: [] }

      let datasetM = {
        backgroundColor: CorUtils.getCorPorNomeSp360('amarelo-medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        label: 'Servidores sexo Masculino',
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'start',
          rotation: -90,
          align: 'end',
          display: 'true',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }

      let datasetF = {
        backgroundColor: CorUtils.getCorPorNomeSp360('amarelo-bistre-medio'),
        borderColor: this.$store.getters.palette.transparent,
        label: 'Servidores sexo Feminino',
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.formatarGrandesNumeros(value),
          anchor: 'start',
          rotation: -90,
          align: 'end',
          display: 'true',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }

      let grupos = _.groupBy(dados, 'raca')

      chartData.labels = Object.keys(grupos)

      dados.forEach(element => {
        if (element) {
          if (element.sexo === 'F') {
            datasetF.data.push(element[prop])
          }
          if (element.sexo === 'M') {
            datasetM.data.push(element[prop])
          }
        }
      })

      chartData.datasets.push(datasetF)
      chartData.datasets.push(datasetM)

      return chartData
    },

    getchartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 25,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }

              return title
            },
            label: function (tooltipItem, details) {
              if (details.datasets[tooltipItem.datasetIndex].label === 'Folha por Orgão' || details.datasets[tooltipItem.datasetIndex].label === 'Distribuição Per capita') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + 'R$' + currentValue.toLocaleString('pt-BR')
              } else if (details.datasets[tooltipItem.datasetIndex].label === 'Acumulado') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + MethGlob.formataPercentual(currentValue)
              } else {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label ? dataset.label + ': ' + currentValue.toLocaleString('pt-BR') : currentValue.toLocaleString('pt-BR')
              }
            },
          },
        },
        responsive: true,
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            distribution: 'linear',

            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              callback: function (value, index, values) {
                if (!isNaN(value)) {
                  return MethGlob.formatarGrandesNumeros(value)
                } else {
                  return value
                }
              },
            },
          }],
          xAxes: [
            {
              position: 'left',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: xAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return value
                },
              },
            },
          ] },
      }
    },

    populateTabelasFolhaPorOrgao (dados) {
      this.tabelaFolhaPorOrgao.data = _.orderBy(dados, 'folha_pagamento_bruta')
      this.tabelaOrgaos.data = _.orderBy(dados, 'nome_secretaria')
      this.tabelaOrgaos.dadosFiltrados = this.tabelaOrgaos.data
      this.tabelaFolhaPerCapita.data = _.orderBy(dados, 'per_capita')
    },

    populatePieChartFaixaEtaria () {
      this.chartFaixaEtaria.data = this.getPieDataset(this.dadosFaixaEtariaSelecionados, this.cores, this.$store.getters.palette.transparent)
      this.chartFaixaEtaria.options = this.getOptionDonutChart()
    },

    getPieDataset (dados, backgroundColor, borderColor) {
      let chartData = { labels: [], datasets: [] }
      let dataset = { data: [], backgroundColor: [] }
      let i = 0
      for (let e in dados) {
        if (!isNaN(dados[e]) && Number(dados[e]) > 0 && e !== 'total') {
          if (this.etariedadeProp && e.includes(this.etariedadeProp)) {
            dataset.data.push(Number(dados[e]))
            dataset.backgroundColor.push(backgroundColor[i++])
            chartData.labels.push(this.getLabelFaixa(e))
          } else if (!this.etariedadeProp && e.length <= 8) {
            dataset.data.push(Number(dados[e]))
            dataset.backgroundColor.push(backgroundColor[i++])
            chartData.labels.push(this.getLabelFaixa(e))
          }
        }
      }
      dataset.borderColor = borderColor
      chartData.datasets.push(dataset)
      return chartData
    },

    getOptionDonutChart () {
      return {
        responsive: true,
        title: {
          display: false,
          text: '',
        },
        tooltips: {
          intersect: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var dataLabel = data.labels[tooltipItem.index]
              var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return (dataLabel += value)
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 50,
            bottom: 50,
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              return MethGlob.formatarGrandesNumeros(value)
            },
            font: {
              size: 16,
            },
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
          },
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            distribution: 'logarithmic',

            scaleLabel: {
              display: true,
              labelString: 'Servidores',
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
            },
          }],
        },
        legend: {
          display: false,
        },
      }
    },

    getLabelFaixa (faixa) {
      let aux = faixa.split('_')
      let min = aux[0].replace('X', '')
      return 'De ' + min + ' a ' + aux[1] + ' anos'
    },

    clickedOrgao (item, index, event) {
      item.selecionado = !item.selecionado
      if (this.orgaoSelecionado !== item.nome) {
        let ultimoSelecionado = this.listaOrgaos.find(e => e.nome === this.orgaoSelecionado)
        if (ultimoSelecionado) ultimoSelecionado.selecionado = false
        this.orgaoSelecionado = item.nome
        this.dadosFaixaEtariaSelecionados = this.dadosFaixaEtaria.porOrgao[item.nome][0]
        this.populatePieChartFaixaEtaria()
      } else {
        this.orgaoSelecionado = 'São Paulo'
        this.dadosFaixaEtariaSelecionados = this.dadosEtariedade
        this.populatePieChartFaixaEtaria()
      }
    },

    rowClass (dataItem, index) {
      return (dataItem['nome_secretaria'] === this.orgaoSelecionado) ? 'red' : 'white'
    },

    carregarListaOrgaos (dados) {
      this.listaOrgaos.push({ nome: 'São Paulo', total: 0, selecionado: false })
      dados.unshift()
      dados.forEach(orgao => {
        let soma = 0
        for (let a in orgao) {
          soma += !isNaN(Number(orgao[a])) ? Number(orgao[a]) : 0
        }
        this.listaOrgaos.push({ nome: orgao.nome, total: soma, selecionado: false })
      })
    },

    nameWithLang ({ nome, selecionado, total }) {
      return `${nome} `
    },

    // TODO: Adicionar Interação com a Legenda. VIDE amcharts pichart legend
    bubbleChart (dados) {
      dados.forEach(e => {
        e.formatado = 'R$' + MethGlob.formatarGrandesNumeros(e.folha_pagamento_bruta)
      })

      dados = _.orderBy(dados, ['nome_secretaria'], 'asc')

      am4core.ready(function () {
        am4core.useTheme(am4themes_animated)
        let chart = am4core.create('chartdiv', am4plugins_forceDirected.ForceDirectedTree)
        let networkSeries = chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries())

        chart.data = dados

        networkSeries.dataFields.value = 'folha_pagamento_bruta'
        networkSeries.dataFields.name = 'nome_secretaria'
        networkSeries.nodes.template.tooltipText = '{nome_secretaria} : {formatado}'
        networkSeries.nodes.template.fillOpacity = 1

        networkSeries.fontSize = 10
        networkSeries.maxRadius = am4core.percent(10)
        networkSeries.minRadius = am4core.percent(0.2)
        networkSeries.manyBodyStrength = -10

        networkSeries.nodes.template.label.text = '{formatado}'
        networkSeries.nodes.template.label.hideOversized = false
        networkSeries.nodes.template.label.truncate = true

        chart.legend = new am4charts.Legend()
        chart.legend.position = 'bottom'
        chart.legend.scrollable = true

        let legendContainer = am4core.create('legenddiv', am4core.Container)
        legendContainer.width = am4core.percent(100)
        legendContainer.height = am4core.percent(100)

        chart.legend.parent = legendContainer

        chart.events.on('datavalidated', resizeLegend)
        chart.events.on('maxsizechanged', resizeLegend)
        chart.legend.events.on('datavalidated', resizeLegend)
        chart.legend.events.on('maxsizechanged', resizeLegend)

        function resizeLegend (ev) {
          document.getElementById('legenddiv').style.height = chart.legend.contentHeight + 'px'
        }
      })
    },

  },
}
</script>

<style lang='scss' scoped>
    .bubble{
        height:30rem;
        width:100%;
    }
    #folhaBar{
        height:40rem
    }
    #legenddiv {
        max-height: 10rem;
    }
    #faixaEtaria{
      box-shadow: none;
      align-self: center;
    }
    ::v-deep .red{
      background-color: #40e583;
    }
    #lista{
      max-height:  35rem;
      overflow-y: scroll;
    }
    #lista::-webkit-scrollbar {
        width: 12px;
    }
    #lista::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
        border-radius: 10px;
    }
    #lista::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
    }
    #tabelaOrgao{
      padding:0;
      
    }
    .toprow{
      max-height: 30rem
    }
    .content{
       height: 100%
    }
    .content::v-deep .va-card__footer{ 
        position: absolute;
        bottom: 0;
        width: 100%;
    }


    .va-card__body{
      height: 100%
    }
</style>
